export default __webpack_public_path__ + "static/media/BD.d0879cc1.png";